"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var Item = _styledComponents.default.div.withConfig({
  displayName: "ContextMenuItem__Item",
  componentId: "sc-15yr176-0"
})(["box-sizing:border-box;width:100%;padding:", " ", " ", " ", ";", " cursor:pointer;", " :hover{background-color:", ";}"], _styles.spacing.xs, _styles.spacing.m, _styles.spacing.xs, _styles.spacing.m, _styles.font.base.regular, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && (0, _styledComponents.css)(["pointer-events:none;color:", ";"], _styles.colors.text.disabled);
}, _styles.colors.background.secondary.default);
var ContextMenuItem = function ContextMenuItem(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    dataCy = _ref2['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
    onClick: onClick,
    disabled: disabled,
    "data-cy": dataCy,
    children: children
  });
};
ContextMenuItem.defaultProps = {};
var _default = exports.default = ContextMenuItem;